<div id="{{ id }}" class="alert alert-warning" role="alert" *ngIf="errors?.length > 0">
	<ul class="mb-0">
		<li *ngFor="let ve of errors">
			{{ ve }}
		</li>
	</ul>
</div>
